import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  Button,
  Dialog,
  TextField,
  Divider,
  useMediaQuery,
  IconButton,
  Container,
} from "@mui/material";
import { styled } from "@mui/system";
import CloseIcon from "@mui/icons-material/Close";
import Swal from "sweetalert2";
import { useTheme } from "@mui/material/styles";

import { useNavigate } from "react-router-dom";
import {
  executeAnyMutation,
  fetchJson,
  fetchJsonDynamic,
} from "../../data/DynamicServiceNew/jsondynamicservice";
import { customerservice } from "../../config";

const StyledCard = styled(Card)(({ theme }) => ({
  padding: theme.spacing(2),
  marginBottom: theme.spacing(2),
}));

export const LoanLimitDialog = ({ onClose, Row }) => {
  const [newLoanLimit, setNewLoanLimit] = useState("");
  const [searchValue, setSearchValue] = useState(null);

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const userId = parseInt(decodedToken.Id);
  const navigate = useNavigate();
  const [Data, setData] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchCustomer = async (searchvalue) => {
    try {
      const response = await fetchJsonDynamic(
        "dynamicCustomerSearch",
        "customer",
        { searchTerm: searchvalue, approval: 2, isAssetCustomer: 2 },
        customerservice.uri,
      );

      const data = JSON.parse(response.results);
      const customer = Array.isArray(data) ? data[0] : data;

      if (!customer) {
        setError("No customer found for the given value.");
        setData(null);

        return;
      }

      setData(customer);
    } catch (err) {
      setError("An error occurred while fetching loan schedule data.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!searchValue) {
      setData(null);

      return;
    }

    const delayDebounce = setTimeout(() => {
      fetchCustomer(searchValue);
    }, 500); // 500ms delay before calling API

    return () => clearTimeout(delayDebounce); // Cleanup timeout on each change
  }, [searchValue]);
  const handleSetLoanLimit = async () => {
    if (!newLoanLimit || isNaN(newLoanLimit)) {
      Swal.fire({
        icon: "warning",
        title: "Invalid Input",
        text: "Please enter a valid loan limit amount.",
      });
      return;
    }

    try {
      const confirmation = await Swal.fire({
        title: "Are you sure?",
        text: `Do you want to update ${Data.FirstName}'s  loan limit to ${newLoanLimit} ?`,
        icon: "warning",
        showCancelButton: true,

        confirmButtonText: "Yes, Set it!",
        cancelButtonText: "No🫷 , cancel",
      });

      if (confirmation.isConfirmed) {
        const mutationData = {
          customerId: Data.Id,
          companyId: Data.CompanyId,
          initiatorId: userId,
          newLoanLimit: parseFloat(newLoanLimit),
          action: 0,
        };

        const response = await executeAnyMutation(
          "updateCustomerLoanLimit",
          mutationData,
          "param",
          false,
          customerservice.uri,
        );

        if (response.results == 201) {
          Swal.fire({
            icon: "success",
            title: "Success!",
            text: `Loan limit updated successfully.`,
          });

          //for ma
        } else if (response.results == 200) {
          Swal.fire({
            title: `unapproved loan limit`,
            text: `${Data.FirstName} has an unapproved loan limit,Please head over to loan limit management and approve based on your role permission`,
            icon: "warning",
            showCancelButton: true,
          });
        } else if (response.error) {
          throw new Error(response.error);
        }
      } else {
        onClose(false);
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    }
  };

  return (
    <Container>
      <Box
        sx={{
          bgcolor: "background.paper",
          p: 4,
          overflowY: "auto",
          maxHeight: "90vh",
          maxWidth: isSmallScreen ? "100vw" : "80vw",
        }}
      >
        <Typography variant="h5" gutterBottom>
          Set Loan Limit
          <Divider
            sx={{ borderBottomWidth: 2, border: "1px solid #003049" }}
            orientation="horizontal"
          />
        </Typography>
        <TextField
          label="Customer Phone Number || Name || Idno"
          variant="outlined"
          fullWidth
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          margin="normal"
        />
        {loading && <Typography>Loading...</Typography>}
        {error && <Typography color="error">{error}</Typography>}
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <StyledCard variant="outlined">
              <Typography variant="subtitle1" gutterBottom>
                <strong>Set Loan Limit</strong>
              </Typography>
              <Typography>
                For Customer:{" "}
                <strong>
                  {" "}
                  {Data?.FirstName}
                  {Data?.OtherNames}
                </strong>
              </Typography>
              <Typography>
                Phone: <strong> {Data?.MobileNumber}</strong>
              </Typography>
            </StyledCard>

            {/* Display Previous Loan Limit */}
            <Box sx={{ mt: 2 }}>
              <TextField
                label="Previous Loan Limit"
                fullWidth
                variant="outlined"
                value={Data?.LoanLimit || "0"}
                disabled
              />
            </Box>

            {/* Input field for new loan limit */}
            <Box sx={{ mt: 2 }}>
              <TextField
                label="Enter New Loan Limit"
                fullWidth
                variant="outlined"
                value={newLoanLimit}
                onChange={(e) => setNewLoanLimit(e.target.value)}
                type="number"
                inputProps={{
                  min: 0,
                  step: 0.01,
                }}
              />
            </Box>

            {/* Submit Button */}
            <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleSetLoanLimit}
                fullWidth
              >
                Set Loan Limit
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};
